export const vitalsCardData = [
  {
    id: 8,
    key: 'distance_details',
    src: require('@assets/images/safehaven/dashboard/distance.png'),
    title: 'Distance',
    unitLong: 'Miles (MI)',
    unitShort: 'MILES',
    currentReading: '3.4',
    minReading: '1.8',
    maxReading: '4.2',
    currentText: 'Total for last 24 hours',
    minText: 'Least Daily',
    maxText: 'Most Daily',
    resultText: 'Message lorem ipsum solor sit',
    status: false,
    showDetails: false,
  },
  {
    id: 7,
    key: 'steps_details',
    src: require('@assets/images/safehaven/dashboard/steps.png'),
    title: 'Steps',
    unitLong: 'Walking & running',
    unitShort: '',
    currentReading: '3400',
    minReading: '200',
    maxReading: '9,876',
    remReading: '200',
    awakeReading: '9,876',
    currentText: 'Total for last 24 hours',
    minText: 'Least Daily',
    maxText: 'Most Daily',
    resultText: 'Message lorem ipsum solor sit',
    status: false,
    showDetails: false,
  },
  {
    id: 5,
    key: 'sleep',
    src: require('@assets/images/safehaven/dashboard/sleep.png'),
    title: 'Sleep',
    unitLong: 'Amount of time',
    unitShort: 'Hours',
    currentReading: '6 0',
    minReading: '6 32',
    maxReading: '10 5',
    remReading: '200',
    awakeReading: '9,876',
    currentText: 'Total for last 24 hours',
    minText: 'Deep',
    maxText: 'Light',
    remText: 'REM',
    awakeText: 'Awake',
    resultText: 'Message lorem ipsum solor sit',
    status: false,
    showDetails: true,
  },
  {
    id: 1,
    key: 'heart_rate_details',
    src: require('@assets/images/safehaven/dashboard/heart-rate.png'),
    title: 'Heart Rate',
    unitLong: 'Beats Per Minute(BPM)',
    unitShort: 'BPM',
    currentReading: '87',
    minReading: '68',
    maxReading: '122',
    currentText: 'Average for last 24 hours',
    minText: 'Minimum',
    maxText: 'Maximum',
    resultText: 'Your heart rate is in normal range',
    status: false,
    showDetails: true,
  },
  // {
  //   id: 2,
  //   key: 'blood_pressure',
  //   src: require('@assets/images/safehaven/dashboard/blood-pressure1.svg'),
  //   title: 'Blood Pressure',
  //   unitLong: 'Millimeters of Mercury (mmHg)',
  //   unitShort: 'mmHg',
  //   currentReading: '117/82',
  //   minReading: '110-120',
  //   maxReading: '79-82',
  //   currentText: 'Current',
  //   minText: 'Systolic Range',
  //   maxText: 'Diastolic Range',
  //   resultText: 'Your blood pressure is normal',
  //   status: false,
  // },
  {
    id: 3,
    key: 'spo2_details',
    src: require('@assets/images/safehaven/dashboard/blood-oxygen.png'),
    title: 'Blood Oxygen Level',
    unitLong: 'Oxygen Saturation (SpO2)',
    unitShort: '%',
    currentReading: '96',
    minReading: '97',
    maxReading: '99',
    currentText: 'Average SpO2 for last 24 hours',
    minText: 'Minimum',
    maxText: 'Maximum',
    resultText: 'Your oxygen saturation is normal',
    status: false,
    showDetails: true,
  },
  // {
  //   id: 4,
  //   key: 'body_temperature',
  //   src: require('@assets/images/safehaven/dashboard/temperature.png'),
  //   title: 'Body Temperature',
  //   unitLong: 'Degrees Fahrenheit(°)',
  //   unitShort: '°F',
  //   currentReading: '98',
  //   minReading: '97.8',
  //   maxReading: '99.2',
  //   currentText: 'Current',
  //   minText: 'Lowest',
  //   maxText: 'Highest',
  //   resultText: 'Your body temperature is normal',
  //   status: false,
  // },

  // {
  //   id: 6,
  //   key: 'body_mass_index',
  //   src: require('@assets/images/safehaven/dashboard/bmi.png'),
  //   title: 'Body Mass Index',
  //   unitLong: 'Weight to height ratio (BMI))',
  //   unitShort: 'BMI',
  //   currentReading: '28.2',
  //   minReading: '19.2',
  //   maxReading: '25.9',
  //   currentText: 'Current',
  //   minText: 'Lowest',
  //   maxText: 'Highest',
  //   resultText: 'Your BMI is in normal range',
  //   status: false,
  // },

  // {
  //   id: 9,
  //   key: 'energy_burned',
  //   src: require('@assets/images/safehaven/dashboard/energy-burned.png'),
  //   title: 'Energy Burned',
  //   unitLong: 'Kcal',
  //   unitShort: 'Kcal',
  //   currentReading: '3.4',
  //   minReading: '1.8',
  //   maxReading: '4.2',
  //   currentText: 'Total calories',
  //   minText: 'Resting',
  //   maxText: 'Active',
  //   resultText: 'Message lorem ipsum solor sit',
  //   status: false,
  //   showDetails: true,
  // },
]

export const responseObj = {
  user_id: '',
  log_id_date: '2022 - 10 - 20',
  heart_rate: {
    min_heart_rate: '67',
    max_heart_rate: '102',
    avg_heart_rate: '82',
    unit: '',
    message: '',
    recommendation: '',
  },
  blood_pressure: {
    systolic_bp: '111',
    diastolic_bp: '88',
    unit: '',
    message: '',
    recommendation: '',
  },
  blood_oxygen_level: {
    min_blood_oxygen_level: '89',
    max_blood_oxygen_level: '98',
    avg_blood_oxygen_level: '96',
    unit: '',
    message: '',
    recommendation: '',
  },
  body_temperature: {
    current_temperature: '98',
    lowest_temperature: '96',
    highest_temperature: '102',
    unit: '',
    message: '',
    recommendation: '',
  },
  sleep: {
    last_night: '6',
    least: '4',
    most: '9',
    unit: '',
    message: '',
    recommendation: '',
  },
  body_mass_index: {
    current_body_mass_index: '28',
    lowest_body_mass_index: '27',
    highest_body_mass_index: '30',
    message: '',
    recommendation: '',
  },
  steps: {
    total_today: '4000',
    least_daily: '3421',
    most_daily: '6398',
    message: '',
    recommendation: '',
  },
  distance: {
    total_today: '3.4',
    least_daily: '2.7',
    most_daily: '5.1',
    unit: '',
    message: '',
    recommendation: '',
  },
}

// export const validicResponseObj = {
//   distance_details: {
//     origin: 'device',
//     unit: 'm',
//     value: '2000.00',
//   },
//   energy_burned: [
//     {
//       origin: 'device',
//       type: 'active_energy_burned',
//       unit: 'kcal',
//       value: '482.00',
//     },
//     {
//       origin: 'device',
//       type: 'basal_energy_burned',
//       unit: 'kcal',
//       value: '1196.00',
//     },
//     {
//       origin: 'device',
//       type: 'energy_burned',
//       unit: 'kcal',
//       value: '1592.00',
//     },
//   ],
//   heart_rate_details: [
//     {
//       origin: 'device',
//       type: 'heart_rate_zone_medium',
//       unit: 's',
//       value: '0.00',
//     },
//     {
//       origin: 'device',
//       type: 'heart_rate_zone_high',
//       unit: 's',
//       value: '0.00',
//     },
//     {
//       origin: 'device',
//       type: 'resting_heart_rate',
//       unit: 'bpm',
//       value: '75.00',
//     },
//   ],
//   sleep: [
//     {
//       origin: 'unknown',
//       type: 'rem_sleep',
//       unit: 's',
//       value: '1620.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'awake_duration',
//       unit: 's',
//       value: '2880.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'light_sleep',
//       unit: 's',
//       value: '6600.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'deep_sleep',
//       unit: 's',
//       value: '7140.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'awake_count',
//       unit: 'count',
//       value: '0.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'time_to_fall_asleep',
//       unit: 's',
//       value: '2160.00',
//     },
//     {
//       origin: 'unknown',
//       type: 'sleep_duration',
//       unit: 's',
//       value: '15360.00',
//     },
//   ],
//   steps: {
//     origin: 'device',
//     unit: 'count',
//     value: '2444.00',
//   },
// }

export const validicResponseObj = {
  distance_details: {
    unit: 'mi',

    today: '1.24',

    last_7day_min: '1.24',

    last_7day_max: '1.24',

    last_7day_avg: '1.24',
  },

  steps_details: {
    unit: 'count',

    today: '2444',

    last_7day_min: '2444',

    last_7day_max: '2444',

    last_7day_avg: '2444',
  },

  heart_rate_details: {
    unit: 'bpm',

    max_heart_rate: '97.00',

    min_heart_rate: '75.00',

    avg_heart_rate: '95.00',

    last_7day_avg: '95',
  },

  // spo2_details: {
  //   unit: 'percent',

  //   max_spo2: '99.00',

  //   min_spo2: '95.00',

  //   avg_spo2: '96.00',

  //   last_7day_avg: '96',
  // },

  sleep: {
    unit: 's',

    today: '4:16:00',

    last_7day_min: '4:16:00',

    last_7day_max: '4:16:00',

    last_7day_avg: '4:16:00',
  },
}
